import { render, staticRenderFns } from "./EmailTemplates.vue?vue&type=template&id=d2314424&scoped=true"
import script from "./EmailTemplates.vue?vue&type=script&lang=js"
export * from "./EmailTemplates.vue?vue&type=script&lang=js"
import style0 from "./EmailTemplates.vue?vue&type=style&index=0&id=d2314424&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2314424",
  null
  
)

export default component.exports